import { inject, bindable } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { NotificationEvent } from './notification'


@inject(EventAggregator)
export class UiMachineNavbar {
	/** MARK: Bindables
		=================================
	**/
	@bindable machine_id;
	@bindable prediction_id;
	/** MARK: Component life cycle methods
		=================================
	 **/
	constructor(ea){
		// Services
		this.ea					= ea
		// Properties
		this.push_message 		= { body:"hello from ui machine navbar" };
		this.show_notification 	= false;
	}
	attached(){
		// Subscriptions
		this.savedPredictionSubs 	= this.ea.subscribe(NotificationEvent.PredictionSaved, msg => this.onSavedPrediction(msg));
		this.removedPredictionSubs 	= this.ea.subscribe(NotificationEvent.PredictionRemoved, msg => this.onRemovedPrediction(msg));
		this.sysErrorSubs		 	= this.ea.subscribe(NotificationEvent.SysError, msg => this.onSysError(msg));
		this.sysMessageSubs		 	= this.ea.subscribe(NotificationEvent.SysMessage, msg => this.onSysMessage(msg));
	}
	detached(){
		this.savedPredictionSubs.dispose();
		this.removedPredictionSubs.dispose();}

	/**	MARK: Listeners
		=================================
	**/

	onSavedPrediction(message){
		this.show_notification = true;
		this.push_message = message;
		window.setTimeout( () => { this.show_notification = false;},3500);
	}

	onRemovedPrediction(message){
		this.backNavi();
	}

	onSysError(message){
		this.show_notification = true;
		this.push_message = message;
		window.setTimeout( () => { this.show_notification = false;},3500);
	}

	onSysMessage(message){
		this.show_notification = true;
		this.push_message = message;
		window.setTimeout( () => { this.show_notification = false;},3500);
	}

	/**	MARK: Custom methods
		=================================
	**/
	// Back navigation button
	backNavi(){ if(history.length != 0){history.back();}}
	onClose(){ this.show_notification = false;}
}
